import React from 'react';
import { AddNewButton } from 'src/components/MainPage/_shared/forms/Buttons';
import {
  PageContainer,
  PageHeader,
  PageContent,
} from 'src/components/MainPage/_shared/page';
import { useActionsAccess } from 'src/hooks/useAuth';

import { Search } from './Search';
import { WarehouseIncomesTable } from './WarehouseIncomesTable';

export const WarehouseIncomesPage = () => {
  const { isReadOnly } = useActionsAccess();
  return (
    <PageContainer>
      <PageHeader title="Приемка на склад">
        {!isReadOnly && <AddNewButton>Добавить вручную</AddNewButton>}
      </PageHeader>
      <PageContent asPaper>
        <Search />
        <WarehouseIncomesTable isReadOnly={isReadOnly} />
      </PageContent>
    </PageContainer>
  );
};
